import type {
  AnnotatedJsonSchema,
  SchemaTransformerArgs,
} from '@web-config-app/core';
import { isArrayOrObjectSchema } from '../../is-array-or-object-schema/is-array-or-object-schema';
import { createObjectCardSchema } from './transformer-utils';

/**
 * Enforces special object card notations that apply to the root node only
 */

export const computeRootNodeSchema = ({ schema }: SchemaTransformerArgs) => {
  if (schema.type !== 'object' || !schema.properties) {
    return schema;
  }

  const mutatedRootNodeSchema = { ...schema };
  const properties: AnnotatedJsonSchema['properties'] = {};

  Object.entries(schema.properties ?? {}).forEach(
    ([propertyName, propertySchema]: [string, AnnotatedJsonSchema]) => {
      if (propertySchema['x-entity-presentation']?.omitFromRoot === true) {
        return;
      }

      if (
        isArrayOrObjectSchema(propertySchema) &&
        propertySchema['x-entity-control']?.type !== 'flattenLayout' &&
        propertySchema['x-entity-presentation']?.omitFromTree !== true
      ) {
        properties[propertyName] = createObjectCardSchema(propertySchema);
        return;
      }

      properties[propertyName] = propertySchema;
    },
  );

  mutatedRootNodeSchema.properties = properties;

  return {
    ...mutatedRootNodeSchema,
    ...(schema.required && {
      required: schema.required.filter((property: string) => {
        const propertySchema = mutatedRootNodeSchema.properties?.[property];
        return (
          propertySchema &&
          propertySchema['x-entity-control']?.type !== 'objectCard'
        );
      }),
    }),
  };
};
